/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Auth_Title4Inputs */

const en_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth & authorization`)
};

const ar_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصادقة والتفويض`)
};

const bn_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অথ ও অথোরাইজেশন`)
};

const de_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierung und Autorisierung`)
};

const es_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticación y autorización`)
};

const fr_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification et autorisation`)
};

const pt_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticação e autorização`)
};

const zh_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份验证和授权`)
};

const tr_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik doğrulama ve yetkilendirme`)
};

const ru_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аутентификация и авторизация`)
};

const pl_svc_backend_development_auth_title4 = /** @type {(inputs: Svc_Backend_Development_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoryzacja i autoryzacja`)
};

/**
* | output |
* | --- |
* | "Auth & authorization" |
*
* @param {Svc_Backend_Development_Auth_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_auth_title4 = /** @type {((inputs?: Svc_Backend_Development_Auth_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Auth_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_auth_title4(inputs)
	if (locale === "bn") return bn_svc_backend_development_auth_title4(inputs)
	if (locale === "de") return de_svc_backend_development_auth_title4(inputs)
	if (locale === "es") return es_svc_backend_development_auth_title4(inputs)
	if (locale === "fr") return fr_svc_backend_development_auth_title4(inputs)
	if (locale === "pt") return pt_svc_backend_development_auth_title4(inputs)
	if (locale === "zh") return zh_svc_backend_development_auth_title4(inputs)
	if (locale === "tr") return tr_svc_backend_development_auth_title4(inputs)
	if (locale === "ru") return ru_svc_backend_development_auth_title4(inputs)
	if (locale === "pl") return pl_svc_backend_development_auth_title4(inputs)
	return en_svc_backend_development_auth_title4(inputs)
});
export { svc_backend_development_auth_title4 as "svc_backend-development_AUTH_title" }